import { required, between, helpers } from 'vuelidate/lib/validators';
import { setImpactedByCovid } from '@/app/utils/toolkit/business-rules/rent-relief/rentReliefDetermination';

const dateIsGreaterThanEqualToStartDateValidator = (value, vm) => (!helpers.req(value) || (value !== '' && vm.start !== '' && value >= vm.start));


export default {
  name: 'rent-relief-determination',
  data: () => ({
    start: '',
    end: '',
  }),
  computed: {
    getItem() {
      return this.$store.getters['toolkit/getItemData'];
    },
    jobKeeper: {
      get() {
        return this.getItem.determination.jobKeeper;
      },
      set(value) {
        this.setItem({ determination: { jobKeeper: value } });
      },
    },
    turnover: {
      get() {
        return this.getItem.determination.turnover;
      },
      set(value) {
        this.setItem({ determination: { turnover: value } });
      },
    },
    turnoverReduction: {
      get() {
        return this.getItem.determination.turnoverReduction;
      },
      set(value) {
        this.setItem({ determination: { turnoverReduction: value } });
      },
    },
    impactedByCovid: {
      get() {
        return this.getItem.determination.impactedByCovid;
      },
      set(value) {
        this.setItem(setImpactedByCovid(value));
      },
    },
  },
  watch: {
    start(value) {
      this.setItem({ determination: { relativePeriod: { start: value } } });
    },
    end(value) {
      this.setItem({ determination: { relativePeriod: { end: value } } });
    },
    '$v.$invalid': {
      immediate: true,
      handler: function isComponentValid(value) {
        this.$emit('valid', !value);
      },
    },

  },
  mounted() {
    this.start = this.getItem.determination.relativePeriod.start !== ''
      ? new Date(this.getItem.determination.relativePeriod.start)
      : '';
    this.end = this.getItem.determination.relativePeriod.end !== ''
      ? new Date(this.getItem.determination.relativePeriod.end)
      : '';
  },
  methods: {
    setItem(item) {
      this.$store.dispatch('toolkit/updateItemKey', { data: item });
    },
    handleNextStep() {
      this.$emit('nextStep');
    },
    handleBackStep() {
      this.$emit('backStep');
    },
    isCheckValid() {
      return true;
    },

  },
  validations: {
    jobKeeper: {
      required,
    },
    turnover: {
      required,
    },
    turnoverReduction: {
      required,
      between: between(0, 100),
    },
    start: {
      required,
    },
    end: {
      required,
      dateIsGreaterThanEqualToStartDateValidator,
    },
    impactedByCovid: {
      required,
    },
  },

};
